// Global
import "./javascripts/common/main";
import "./style.scss";
